
<ng-container *ngIf="asmdetails=='true' && isAsmUser">
     <div class="col-xs-12 col-sm-12 myprofile_consentsection no-padding" >
          <div class="myprofile_consentcontainer" [ngClass]="{'asm_User_Consentcontainer': isAsmUser}">  
                <div class="myprofile_consentheader">{{ukConsentPopupData?.headline}}</div>  
                <div class="myprofile_consentcontent"> 
                     <span>{{ukConsentPopupData?.message1}}</span>
                                    <span class="consentsubheader_mail">{{consentdata?.marketingConsentEmailId}}</span>
                                         <span>{{ukConsentPopupData?.message2}} </span>
                                         <span class="consent_privacypolicy">
                                              <a target="_blank" href={{ukConsentPopupData?.button}}>privacy policy</a>.
                                         </span>
                </div> 
            <div class="myprofile_radiocontainer" [ngClass]="{'asm_radiocontainer': isAsmUser}">
                  <label class="myprofile_radio">
                     <!--disabling when it is an Asm user-->
                       <input type="radio"  class="myprofile_radiobtn" id="myprofile_radiobtn1" value="true" [checked]="consentdata?.isConsentGranted==true?'checked':''" [disabled]="isAsmUser" (change)="onRadiochange(true)"><span class="myprofile_radiobtncontrol"></span><label for="myprofile_radiobtn1">{{ukConsentPopupData?.content}}</label>
                  </label>
                </div>
                <div class="myprofile_radiocontainer" [ngClass]="{'asm_radiocontainer': isAsmUser}">
                  <label class="myprofile_radio">
                      <!--disabling when it is an Asm user-->
                       <input type="radio"  class="myprofile_radiobtn" id="myprofile_radiobtn2" value="false" [checked]="consentdata?.isConsentGranted==false?'checked':''" [disabled]="isAsmUser" (change)="onRadiochange(false)"><span class="myprofile_radiobtncontrol"></span><label for="myprofile_radiobtn2">{{ukConsentPopupData?.label1}}</label>
                  </label>
               </div>
              <!--iam displaying when it is not an asm user--> 
                <button type="button" id="myprofile_updatebtn" *ngIf="!isAsmUser" (click)="submitconsent()">{{ukConsentPopupData?.thankYouMessage}}</button>   
                <div class="myprofile_consentsuccess" [ngClass]="successshow?'show':''">{{ukConsentPopupData?.label2}}</div>
              </div>  
       </div>
</ng-container>
<ng-container *ngIf="!isAsmUser">
     <div class="col-xs-12 col-sm-12 myprofile_consentsection no-padding" >
          <div class="myprofile_consentcontainer" [ngClass]="{'asm_User_Consentcontainer': isAsmUser}">  
                <div class="myprofile_consentheader">{{ukConsentPopupData?.headline}}</div>  
                <div class="myprofile_consentcontent"> 
                     <span>{{ukConsentPopupData?.message1}}</span>
                                    <span class="consentsubheader_mail">{{consentdata?.marketingConsentEmailId}}</span>
                                         <span>{{ukConsentPopupData?.message2}} </span>
                                         <span class="consent_privacypolicy">
                                              <a target="_blank" href={{ukConsentPopupData?.button}}>privacy policy</a>.
                                         </span>
                </div> 
            <div class="myprofile_radiocontainer" [ngClass]="{'asm_radiocontainer': isAsmUser}">
                  <label class="myprofile_radio">
                     <!--disabling when it is an Asm user-->
                       <input type="radio"  class="myprofile_radiobtn" id="myprofile_radiobtn1" value="true" [checked]="consentdata?.isConsentGranted==true?'checked':''" [disabled]="isAsmUser" (change)="onRadiochange(true)"><span class="myprofile_radiobtncontrol"></span><label for="myprofile_radiobtn1">{{ukConsentPopupData?.content}}</label>
                  </label>
                </div>
                <div class="myprofile_radiocontainer" [ngClass]="{'asm_radiocontainer': isAsmUser}">
                  <label class="myprofile_radio">
                      <!--disabling when it is an Asm user-->
                       <input type="radio"  class="myprofile_radiobtn" id="myprofile_radiobtn2" value="false" [checked]="consentdata?.isConsentGranted==false?'checked':''" [disabled]="isAsmUser" (change)="onRadiochange(false)"><span class="myprofile_radiobtncontrol"></span><label for="myprofile_radiobtn2">{{ukConsentPopupData?.label1}}</label>
                  </label>
               </div>
              <!--iam displaying when it is not an asm user--> 
                <button type="button" id="myprofile_updatebtn" *ngIf="!isAsmUser" (click)="submitconsent()">{{ukConsentPopupData?.thankYouMessage}}</button>   
                <div class="myprofile_consentsuccess" [ngClass]="successshow?'show':''">{{ukConsentPopupData?.label2}}</div>
              </div>  
       </div>
</ng-container>

<!--new-->
<!-- <div class="col-xs-12 col-sm-12 myprofile_consentsection no-padding" *ngIf="!showStatus()">
<div class="myprofile_consentcontainer" >
  <div class="myprofile_consentheader">{{ukConsentPopupData?.link}}</div>
  <div [innerHTML]="ukConsentPopupData.content"></div> -->
  <!-- <div class="myprofile_consentcontent">
  <span>{{ukConsentPopupData?.message1}}</span>
  <span class="consentsubheader_mail">{{consentdata?.marketingConsentEmailId}}</span>
  <span>{{ukConsentPopupData?.message2}} </span>
  <span class="consent_privacypolicy">
    <a target="_blank" href={{ukConsentPopupData?.button}}>privacy policy</a>.
  </span>
</div> -->
<!-- <div class="uk_Consent_List">
<div class="uk_Consent_Li_Item">
  <img class="uk_Consent_Icons" src="../../../assets/images/idea.svg">
  <div class="uk_Consent_Li_Txt" [innerHTML]="ukConsentPopupData.message3"></div>
</div>
<div class="uk_Consent_Li_Item">
  <img class="uk_Consent_Icons" src="../../../assets/images/calendar.svg">
  <div class="uk_Consent_Li_Txt" [innerHTML]="ukConsentPopupData.label1"></div>
</div>
<div class="uk_Consent_Li_Item">
  <img class="uk_Consent_Icons" src="../../../assets/images/notificationicon.svg">
  <div class="uk_Consent_Li_Txt" [innerHTML]="ukConsentPopupData.label2"></div>
</div>

</div>  -->
<!-- <div class="myprofile_radiocontainer">
<label class="myprofile_radio">
  <input type="radio"  class="myprofile_radiobtn" id="myprofile_radiobtn1" value="true" [checked]="consentdata?.isConsentGranted==true?'checked':''" (change)="onRadiochange(true)">
  <span class="myprofile_radiobtncontrol"></span>
  <div class="yes_Msg_Box col-md-11 conset_Txt_Wrap">
    <span class="myprofile_radiobtn1" [innerHTML]="ukConsentPopupData?.message1"></span>
    <span class="email_Consent_Txt">{{consentdata?.marketingConsentEmailId}}</span>
    <span class="myprofile_radiobtn1 consent_Radio_Txt" [innerHTML]="ukConsentPopupData?.message2"></span>
  </div> -->
  <!-- <label for="myprofile_radiobtn1">{{ukConsentPopupData?.message1}}</label>
  <label></label> -->
<!-- </label>
</div>
<div class="myprofile_radiocontainer">
  <label class="myprofile_radio">
    <input type="radio"  class="myprofile_radiobtn" id="myprofile_radiobtn2" value="false" [checked]="consentdata?.isConsentGranted==false?'checked':''"  (change)="onRadiochange(false)"><span class="myprofile_radiobtncontrol"></span><span class="myprofile_radiobtn2 consent_Radio_Txt col-md-11 conset_Txt_Wrap" [innerHTML]="ukConsentPopupData?.thankYouMessage"></span>
  </label>
</div>
<button type="button" id="myprofile_updatebtn" (click)="submitconsent()">Update</button>
<div class="myprofile_consentsuccess" [ngClass]="successshow?'show':''">{{ukConsentPopupData?.name}}</div>
</div>
</div> -->
